import { render, staticRenderFns } from "./ProcessingBatchList.vue?vue&type=template&id=5f0e3f51"
import script from "./ProcessingBatchList.vue?vue&type=script&lang=js"
export * from "./ProcessingBatchList.vue?vue&type=script&lang=js"
import style0 from "./ProcessingBatchList.vue?vue&type=style&index=0&id=5f0e3f51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports